import AddressInputs from "./address-inputs";
import CompareGraph from "./graph";

import { ReactComponent as CloseIcon } from '../../assets/cancel-white.svg';

import ClickOutsideHandler from '../../utility/ClickOutsideHandler';

const InputsGraphPopup = ({ state, dispatch }) => {

  const closeCompareInputsGraph = () => {
    dispatch({ type: 'SET_SHOW_COMPARE_INPUTS_GRAPH', payload: false });
  };

  return (
    <div className="compare-inputs-graph absolute inset-0 flex items-center justify-center bg-black/60 z-[9999]">
      <CloseIcon className='absolute top-4 right-4 h-5 w-auto cursor-pointer' onClick={() => closeCompareInputsGraph()}/>
      <ClickOutsideHandler
        className="flex items-center justify-center gap-4 bg-black p-4 rounded-lg"
        onOutsideClick={closeCompareInputsGraph}
      >
        <AddressInputs state={state} dispatch={dispatch} />
        <CompareGraph state={state} dispatch={dispatch} />
      </ClickOutsideHandler>
    </div>
  )
};

export default InputsGraphPopup;